import { render, staticRenderFns } from "./RegisterPriceTicket.vue?vue&type=template&id=a5b48f32&"
import script from "./RegisterPriceTicket.vue?vue&type=script&lang=js&"
export * from "./RegisterPriceTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports